import { Http } from 'Utils/Http';
import { IBaseResponse } from './interfaces/BaseResponse';
import {
  IAcceptTermsRequest,
  IPublicTermsAcceptanceResponse,
} from './interfaces/Faturamento/ITermsAcceptance';

// Página pública do link de ciência nos Termos de Uso (TermsAcceptanceController,
// rotas [AllowAnonymous]). Quem abre o link normalmente não tem login: é o
// representante legal de uma SPE. Http.axios() só envia o token quando existe.
export class TermsAcceptanceApi {
  static async getByToken(token: string): Promise<IPublicTermsAcceptanceResponse> {
    const axios = await Http.axios(false);
    const response = await axios.get<IBaseResponse<IPublicTermsAcceptanceResponse>>(
      `/v2/terms-acceptances/${encodeURIComponent(token)}`
    );
    return response.data.data;
  }

  static async accept(
    token: string,
    request: IAcceptTermsRequest
  ): Promise<IPublicTermsAcceptanceResponse> {
    const axios = await Http.axios(false);
    const response = await axios.post<IBaseResponse<IPublicTermsAcceptanceResponse>>(
      `/v2/terms-acceptances/${encodeURIComponent(token)}/accept`,
      request
    );
    return response.data.data;
  }
}
